import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { enableProdMode } from "@angular/core";

import { AppModule } from "./app.module";

if (!window.location.origin.startsWith("http://localhost")) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("service-worker.js")
    .then(function(swReg) {
      console.log("Service Worker is registered", swReg);
    })
    .catch(err => console.error("Error", err));
}



// WEBPACK FOOTER //
// ./src/app/main.ts